import React from "react";
import { m as motion } from "../../../shared/components/Motion";
import { childVariants } from "shared/utils";
import { ButtonComponent } from "../../../shared/components";

/**
 * AuthSection Component
 * Displays sign in/sign out functionality
 */
const AuthSection = ({ isAdmin, isSigningIn, onSignIn, onSignOut }) => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={childVariants}
      style={{
        padding: "0.5rem",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem",
      }}
    >
      {isAdmin ? (
        <ButtonComponent
          buttonTitle="Sign Out"
          buttonText="Sign Out"
          onClick={onSignOut}
          className="signout-btn"
        >
          <i className="bx bx-log-out"></i>
          <span>Sign Out</span>
        </ButtonComponent>
      ) : (
        <>
          <ButtonComponent
            buttonTitle={isSigningIn ? "Signing in..." : "Sign In with Google"}
            buttonText={isSigningIn ? "" : "Sign with Google"}
            onClick={onSignIn}
            disabled={isSigningIn}
            className="signin-btn"
          >
            {isSigningIn ? (
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity }}
                style={{ display: "flex" }}
              >
                <i className="bx bx-loader"></i>
              </motion.div>
            ) : (
              <>
                <i style={{ fontSize: "1rem" }} className="bx bxl-google"></i>
                <span>Santhosh's Login</span>
              </>
            )}
          </ButtonComponent>
        </>
      )}
    </motion.div>
  );
};

export default AuthSection;
